import { render, staticRenderFns } from "./DataModelProgram.vue?vue&type=template&id=bcb84ede&scoped=true&"
import script from "./DataModelProgram.vue?vue&type=script&lang=js&"
export * from "./DataModelProgram.vue?vue&type=script&lang=js&"
import style0 from "./DataModelProgram.vue?vue&type=style&index=0&id=bcb84ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb84ede",
  null
  
)

export default component.exports